import React, { FC } from "react";
import { IconContainer } from "shared/icons/IconContainer";

export const LongTextBlockIcon: FC<React.ComponentProps<typeof IconContainer>> = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.60156 3.8002C1.60156 3.46882 1.87019 3.2002 2.20156 3.2002H13.8016C14.1329 3.2002 14.4016 3.46882 14.4016 3.8002C14.4016 4.13157 14.1329 4.4002 13.8016 4.4002H2.20156C1.87019 4.4002 1.60156 4.13157 1.60156 3.8002ZM1.60156 8.0002C1.60156 7.66882 1.87019 7.4002 2.20156 7.4002H13.8016C14.1329 7.4002 14.4016 7.66882 14.4016 8.0002C14.4016 8.33157 14.1329 8.6002 13.8016 8.6002H2.20156C1.87019 8.6002 1.60156 8.33157 1.60156 8.0002ZM1.60156 12.2002C1.60156 11.8688 1.87019 11.6002 2.20156 11.6002H13.8016C14.1329 11.6002 14.4016 11.8688 14.4016 12.2002C14.4016 12.5316 14.1329 12.8002 13.8016 12.8002H2.20156C1.87019 12.8002 1.60156 12.5316 1.60156 12.2002Z"
      fill="currentColor"
    />
  </IconContainer>
);
